class PopupRegister {
    static check() {
        window._popup_history = window._popup_history || [];
    }

    static push(obj) {
        this.check();
        window._popup_history.push(obj);
    }

    static history() {
        return window._popup_history;
    }

    static last() {
        this.check();

        if (window._popup_history.length > 0)
            return window._popup_history[window._popup_history.length - 1];

        return undefined;
    }

    static pop() {
        this.check();
        return window._popup_history.pop();
    }
}

export default PopupRegister;